import Vue from 'vue'
import VueMqDdExtension from './dd-extensions/vue-mq-dd-extension/index'

Vue.use(VueMqDdExtension)
